import Project from "../project"
import {toMomentDate} from "../../../gd/convert/moment-date"

export default function projectUpdateEndDate(project:Project, endDate:Moment|null) {
    project.endDate = toMomentDate(endDate)

    // if we set start date to null, end date should be null too
    if (endDate === null) {
        project.startDate = null
    }

    if (project.endDate && !project.startDate) {
        project.startDate = toMomentDate(project.endDate)
    }

    // if endDate BEFORE start set start = end because we update START here
    if (project.endDate && project.startDate && project.endDate.isBefore(project.startDate,'days')) {
        project.startDate = toMomentDate(project.endDate)
    }
}